import ProposalListPage from './ProposalListPage';

export default ProposalListPage;